import styled, { css } from 'styled-components';
import { Input } from 'reactstrap';

export default styled(Input)`
  border-color: ${({ theme }) => theme.colors.semantic.border.default};
  background-color: ${({ theme }) => theme.colors.semantic.surface.card};
  color: ${({ theme }) => theme.colors.semantic.text.primary};
  padding: 8px 12px;
  border-radius: 8px;
  box-shadow: none;

  &.form-control::placeholder,
  &::placeholder {
    line-height: 1;
    letter-spacing: 0.5px;
    font-size: 14px;
    color: ${({ theme }) => theme.colors.semantic.text.secondary};
  }

  &:disabled {
    cursor: not-allowed;
    background-color: ${({ theme }) => theme.colors.semantic.surface.muted};
    color: ${({ theme }) => theme.colors.semantic.text.secondary};
  }

  &[readonly] {
    background-color: ${({ theme }) => theme.colors.semantic.surface.muted};
    color: ${({ theme }) => theme.colors.semantic.text.primary};
  }

  &:focus {
    background-color: ${({ theme }) => theme.colors.semantic.surface.card};
    color: ${({ theme }) => theme.colors.semantic.text.primary};
    border-color: ${({ theme }) => theme.colors.semantic.action.primary};
    box-shadow: 0 0 0 0.2rem
      ${({ theme }) => theme.colors.semantic.surface.selection};
    outline: none;
  }

  &:hover {
    border-color: ${({ theme }) => theme.colors.semantic.action.primary};
  }

  &.form-control:focus,
  &.form-control:focus-visible {
    background-color: ${({ theme }) => theme.colors.semantic.surface.card};
    color: ${({ theme }) => theme.colors.semantic.text.primary};
    border-color: ${({ theme }) => theme.colors.semantic.action.primary};
    box-shadow: 0 0 0 0.2rem
      ${({ theme }) => theme.colors.semantic.surface.selection};
    outline: none;
  }

  ${props =>
    props.invalid &&
    css`
      border-color: ${props.theme.colors.danger500};

      &:hover,
      &:focus,
      &.form-control:focus,
      &.form-control:focus-visible {
        border-color: ${props.theme.colors.danger500};
        box-shadow: none;
      }
    `}

  ${props =>
    props.$withoutArrowNumber &&
    css`
      &::-webkit-outer-spin-button,
      &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
      &[type='number'] {
        -moz-appearance: textfield;
      }
    `}
`;
